<div [ngClass]="filterLabel ? 'filter-label' : 'form-label'">Employee</div>
<ng-select
  (click)="$event.stopPropagation()"
  class="typeahead"
  id="select_employee"
  [multiple]="true"
  [items]="(employeeOptions$ | async) ?? []"
  [(ngModel)]="selectedEmployees"
  (ngModelChange)="changeSelection()"
  (keydown)="changeSelection()"
  bindValue="value"
  bindLabel="option"
  placeholder="Select one or more employees">
</ng-select>
